import React, { useState } from "react";
import SignalControls from "./components/SignalControls";
import SignalsTable from "./components/SignalsTable";

const AutomationsOverviewPage = () => {
    const [selectedFilter, setSelectedFilter] = useState("all");
    const [selectedState, setSelectedState] = useState("all");
    return (
        <>
            <SignalControls
                selectedFilter={selectedFilter}
                selectedState={selectedState}
                setSelectedFilter={setSelectedFilter}
                setSelectedState={setSelectedState}
                title="Automations"
            />
            <SignalsTable
                selectedFilter={selectedFilter}
                selectedState={selectedState}
                automationType="automation"
            />
        </>
    );
};

export default AutomationsOverviewPage;
